/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const staffUploadPictureSchema = z.object({
	picture: z.url(),
});
